import React from "react";

export function WRookIcon({ color = "#3C3C3C" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 112 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.8836 47.4343C47.426 44.6375 65.0877 45.2498 82.311 47.4343ZM14.7142 6.79685C10.7079 39.932 18.8868 47.1509 28.8836 47.4343L16.3507 116.067H94.8402L82.311 47.4343C92.3079 47.1546 100.479 39.932 96.4767 6.79685L82.8402 4.7937L78.7847 18.5663L66.9095 18.1883L64.9365 4H46.2468L44.2814 18.1883L32.4024 18.5663L28.3469 4.79748L14.7142 6.79685Z"
        fill="#F0F0F0"
      />
      <path
        d="M28.8836 47.4343C47.426 44.6375 65.0877 45.2498 82.311 47.4343M28.8836 47.4343C18.8868 47.1509 10.7079 39.932 14.7142 6.79685L28.3469 4.79748L32.4024 18.5663L44.2814 18.1883L46.2468 4H64.9365L66.9095 18.1883L78.7847 18.5663L82.8402 4.7937L96.4767 6.79685C100.479 39.932 92.3079 47.1546 82.311 47.4343M28.8836 47.4343L16.3507 116.067H94.8402L82.311 47.4343"
        stroke={color}
        stroke-width="8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.5973 108.069C55.5973 108.069 21.0902 108.251 11.4109 114.192C4.88362 118.198 3.34157 127.987 4.22976 138.09H106.965C107.853 127.991 106.315 118.195 99.7838 114.188C90.1082 108.254 55.5973 108.069 55.5973 108.069Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
    </svg>
  );
}
